module.exports = __webpack_public_path__ + "static/media/offerteaanvaard_white.a6270d6e.svg";